import { createFileRoute, useParams, useSearch } from '@tanstack/react-router';
import { ssoAuthorize } from '@vizit/auth';
import { SsoDirectLogin } from '@vizit/organisms';
import * as React from 'react';

type SsoDirectSearch = {
  login_hint?: string;
  redirect?: string;
};

export const Route = createFileRoute('/_auth/sso/$orgSlug')({
  staticData: {
    pageName: 'SSO Direct Login',
  },
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): SsoDirectSearch => {
    return {
      login_hint: (search.login_hint as string) ?? undefined,
      redirect: (search.redirect as string) ?? undefined,
    };
  },
});

function RouteComponent() {
  const { orgSlug } = useParams({ from: Route.id });
  const { login_hint: loginHint, redirect: redirectFromSearch } = useSearch({ from: Route.id });

  const safeRedirect =
    redirectFromSearch?.startsWith('/') && !redirectFromSearch.startsWith('//') ? redirectFromSearch : '/';

  const handleAuthorize = React.useCallback(
    async (slug: string, hint: string) => {
      const data = await ssoAuthorize({
        orgSlug: slug,
        loginHint: hint,
        redirect: safeRedirect,
      });
      return data.authorize_url;
    },
    [safeRedirect],
  );

  return (
    <div className="h-screen w-screen flex flex-col justify-center items-center">
      <SsoDirectLogin orgSlug={orgSlug} loginHint={loginHint} onAuthorize={handleAuthorize} />
    </div>
  );
}
